import React from "react";
import { CreateIdCheckTaskStatus } from "../components/CreateIdCheckTaskStatus";
import { useSelector } from "react-redux";

export const CreateIdCheckTaskStatusContainer = () => {
  const isFetching = useSelector(
    (state: any) => state.order.createIdCheckTask?.fetching
  );
  const isSuccess = useSelector(
    (state: any) =>
      state.order.createIdCheckTask?.response?.status === "success"
  );
  const isError = useSelector(
    (state: any) => state.order.createIdCheckTask?.response?.status === "error"
  );
  const successMessage = useSelector(
    (state: any) => state.order.createIdCheckTask?.response?.data?.message
  );
  const errorMessage = useSelector(
    (state: any) => state.order.createIdCheckTask?.response?.message
  );
  return (
    <CreateIdCheckTaskStatus
      isFetching={isFetching}
      isSuccess={isSuccess}
      isError={isError}
      successMessage={successMessage}
      errorMessage={errorMessage}
    />
  );
};
